class MediaVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video');
    if (!this.video) {
      return;
    }

    this.isMobile = window.matchMedia('(max-width: 959px)');

    this.mobile_poster = this.video.dataset.mobilePoster || this.video.dataset.desktopPoster;
    this.desktop_poster = this.video.dataset.desktopPoster || this.video.dataset.mobilePoster;

    if (this.isMobile.matches) {
      this.video.setAttribute('poster', this.mobile_poster);

      return;
    }

    this.video.setAttribute('poster', this.desktop_poster);
  }
}

// Define the custom element
customElements.define('media-video', MediaVideo);
